module.exports = __webpack_public_path__ + "img/class-completed.f27976bf.png";